import axios from 'config/axios';

export async function getWallets(body) {
  try {
    const response = await axios.post("/AogGetCustomerEcryptWallet", body);
    if (response.data.status === "success") {
      return {data: response.data.data, error: null}
    }
    return {data: null, error: response.data.message || "Something went wrong"}
  } catch (error) {
    console.error('❌ Error fetching wallets:', error);
    return {data: null, error}
  }
}

export async function createWallet(body) {
  try {
    const response = await axios.post("/AogCreateCustomerEcryptWallet", body);
    if (response.data.status === "success") {
      return {error: false, message: response.data.message}
    }
    return {error: true, message: response.data.message || "Something went wrong"}
  } catch (error) {
    console.error('❌ Error creating wallet:', error);
    return {error: true, message: error.message || "Something went wrong"}
  }
}

export async function setDefaultOrDeleteWallet(body) {
  try {
    const response = await axios.post("/AogUpdateOrDeleteCustomerEcryptWallet", body);
    if (response.data.status === "success") {
      return {error: false, message: response.data.message}
    }
    return {error: true, message: response.data.message || "Something went wrong"}
  } catch (error) {
    console.error('❌ Error setting default or deleting wallet:', error);
    return {error: true, message: error.message || "Something went wrong"}
  }
}